import Vue from "vue";
import VueI18n from "vue-i18n";

import enLocale from "./locales/en.json";
import zhLocale from "./locales/zh.json";
import jaLocale from "./locales/ja.json";

Vue.use(VueI18n);

const messages = {
  en: enLocale,
  zh: zhLocale,
  ja: jaLocale,
};

const userLang = localStorage.getItem("display_lang");

const i18n = new VueI18n({
  locale: userLang || "zh",
  fallbackLocale: "zh",
  messages,
});

export default i18n;
